module.exports = __webpack_public_path__ + "static/media/Residential_27.ec1ba9a3.jpg";